import { generateTranslations } from '../../i18n/translation';

const namespace = 'addSystembruker';

const translations = generateTranslations(namespace, {
  btnLabel: { nb: 'Legg til systembruker', en: 'Add admin user' },
  labelEpost: { nb: 'Epostadresse', en: 'Email address' },
  labelEtternavn: { nb: 'Etternavn', en: 'Last name' },
  labelFeideId: { nb: 'Feide-id', en: 'Feide-id' },
  labelFnr: { nb: 'Personnummer', en: 'Identity number' },
  labelFornavn: { nb: 'Fornavn', en: 'First name' },
  pageTitle: {
    nb: 'Legg til ny systembruker',
    en: 'Add new admin user',
  },
  pageSubtitle: {
    nb: 'Et skjema for å legge inn nye systembrukere. Merk at det ikke sendes ut noen invitasjon, og at nye brukere vil være aktive umiddelbart. Feide-id må ligge under Sikt (dvs. at det må sendes inn på formen "feide-id@sikt.no").',
    en: 'A schema for adding new admin users. Note that no invitation will be sent, and that new users will be concidered active immediately. Feide-id must be from Sikt (i.e. they must be on the form "feide-id@sikt.no").',
  },
  placeholderEpost: {
    nb: 'Fyll inn epostadresse (trenger ikke å være lik feide-id)',
    en: 'Fill in email address (does not have to be equal to feide-id)',
  },
  placeholderEtternavn: { nb: 'Fyll inn etternavn', en: 'Fill in last name' },
  placeholderFeideId: {
    nb: 'Fyll inn feide-adresse på formen "feide-id@sikt.no" (feide-id er kortform av brukernavn)',
    en: 'Fill in feide address on the form "feide-id@sikt.no" (feide-id is the short version of user names)',
  },
  placeholderFnr: {
    nb: 'Fyll inn personnummer',
    en: 'Fill in the identity number',
  },
  placeholderFornavn: {
    nb: 'Fyll inn fornavn - (Sikt) legges automatisk inn som mellomnavn',
    en: 'Fill in first name - (Sikt) is automatically added as a middle name',
  },
  success: {
    nb: 'Systembruker ble lagt til',
    en: 'Admin user added',
  },
});

export default translations;
